import { Route, Routes } from 'react-router-dom'
import { Questionnaire } from '../pages/main'
import { Detail } from '../pages/detail'
import { lazy, Suspense } from 'react'
import Loader from '../../../components/loader'
import { QuestionnaireProvider } from '../pages/detail/contextProvider/provider'
import LinkingUsersToQuestionnaires from '../pages/permission'
import { QuestionnaireFormProvider } from '../context/provider'
import { ExecutionDetail } from '../pages/executionDetail'
import ProtectedRoute from './protectedRoute'

const Header = lazy(() => import('../pages/create'))
const PreviewQuestionnaire = lazy(() => import('../pages/preview').then(({ PreviewQuestionnaire }) => ({ default: PreviewQuestionnaire })))
const DetailProvider = () => <QuestionnaireProvider><Detail /></QuestionnaireProvider>

const QuestionnaireRoute = () => {
  return (
    <QuestionnaireFormProvider>
      <Routes>
        <Route path="main" element={<Questionnaire />} />
        <Route path="header" element={<ProtectedRoute><Header /></ProtectedRoute>} />
        <Route path="header/:id" element={<ProtectedRoute><Header /></ProtectedRoute>} />
        <Route path="create" element={<ProtectedRoute><DetailProvider /></ProtectedRoute>} />
        <Route path="edit/:id" element={<ProtectedRoute><DetailProvider /></ProtectedRoute>} />
        <Route path="permission/:id" element={<ProtectedRoute><LinkingUsersToQuestionnaires /></ProtectedRoute>} />
        <Route path="preview/:id" element={<ProtectedRoute><PreviewQuestionnaire /></ProtectedRoute>} />
        <Route path="execution/:id" element={<ExecutionDetail />} />
      </Routes>
    </QuestionnaireFormProvider>
  )
}

export default QuestionnaireRoute
